export const layout = {
  sidebar: {
    appName: 'Referent',
    toggleSidebar: 'Alternar barra lateral',
    currentOrganization: 'Organización Actual',
    openSergeo: 'Abrir Sergeo',
    orgSwitcher: {
      label: 'Cambiar de organización',
      noOrganization: 'Sin organización seleccionada',
      switchError: 'No se pudo cambiar de organización',
      viewingOrganization: 'Estás viendo {{name}}',
    },
  },
  sidebarNav: {
    overview: 'Resumen',
    overviewSummary: 'Panel',
    overviewAiTraffic: 'Tráfico desde IA',
    overviewDeliverables: 'Entregables',
    collaborators: 'Colaboradores',
    main: 'Principal',
    content: 'Contenido',
    research: 'Auditorías',
    tools: 'Herramientas',
    dashboard: 'Dashboard',
    brandVoices: 'Voces de Marca',
    contentGenerator: 'Generador de Contenido',
    newContent: 'Nuevo Contenido',
    myContents: 'Mis Contenidos',
    bulkGeneration: 'Generación Masiva',
    geoAuditor: 'Auditor GEO',
    organization: 'Organización',
    companySettings: 'Configuración de Empresa',
    logout: 'Cerrar sesión',
    settings: 'Configuración',
    support: 'Soporte',
    superAdmin: 'Dashboard Super-Admin',
    superAdminDeliverables: 'Entregables (Super-Admin)',
    contentPlan: 'Plan de Contenidos',
    keywordResearch: 'Investigación de Keywords',
    competitiveAnalysis: 'Análisis Competitivo',
    keywordGap: 'Keyword Gap',
    keywordPositioning: 'Posicionamiento de Keywords',
    data: 'Visibilidad en IA',
    dataDashboard: 'Vista general',
    dataPrompts: 'Prompts',
    dataPromptsList: 'Todos los prompts',
    dataResponses: 'Respuestas',
    dataSources: 'Fuentes',
    dataActions: 'Acciones',
    aiKeywordExpansion: 'Expansión IA de Keywords',
    seoAudit: '360 Audit',
    prospectAudits: 'Auditorías de Prospectos',
    landingPages: 'Landing Pages',
    socialAnalytics: 'Métricas de LinkedIn',
    contentOptimization: 'Optimizador',
    nativeContent: 'Motor de Contenidos',
    knowledgeBase: 'Base de conocimiento',
    trendFilter: 'Filtro de Tendencias',
    sergeo: 'Sergeo',
    integrations: 'Integraciones',
    seo: 'SEO',
    seoSummary: 'Resumen',
    seoDetails: 'Detalle SEO',
    aiVisibility: 'Visibilidad en IA',
    aiVisibilityAiTraffic: 'Tráfico de IA',
    aiVisibilityShareOfVoice: 'Share of Voice',
    aiVisibilityPrompts: 'Prompts',
    workspace: 'Workspace',
    workspaceDeliverables: 'Entregables',
  },
  language: {
    english: 'English',
    selectLanguage: 'Seleccionar Idioma',
    spanish: 'Español',
  },
  dashboard: {
    welcome: 'Bienvenido',
    welcomeBack: 'Bienvenido de nuevo, {{name}}',
    welcomeMessage: 'Gestiona tus proyectos SEO y GEO de manera eficiente',
    overview: 'Esto es lo que está ocurriendo con tus campañas SEO y GEO hoy.',
    quickActions: 'Accesos Rápidos',
    metrics: {
      activeCampaigns: {
        title: 'Campañas Activas',
        description: 'Tus campañas en ejecución actualmente',
        value: '12',
        delta: '+2 desde el mes pasado',
      },
      totalReach: {
        title: 'Alcance Total',
        description: 'Impresiones durante este mes',
        value: '45.2K',
        delta: '+18% desde el mes pasado',
      },
      conversionRate: {
        title: 'Tasa de Conversión',
        description: 'Promedio en todas las campañas',
        value: '3.2%',
        delta: '+0.5% desde el mes pasado',
      },
    },
    stats: {
      activeProjects: 'Proyectos Activos',
      recentActivity: 'Actividad Reciente',
      performance: 'Rendimiento',
      descriptions: {
        activeProjects: 'Proyectos activos este mes',
        recentActivity: 'Conteo de actividad reciente',
        performance: 'Rendimiento general',
      },
      comparisons: {
        projectsIncrease: '+18% desde el mes pasado',
        activityIncrease: '+5% desde la semana pasada',
        performanceStatus: 'En progreso',
      },
    },
    actions: {
      manageOrganization: 'Gestionar Organización',
      viewSettings: 'Configuración',
    },
    recentActivity: {
      title: 'Actividad Reciente',
      description: 'Tus últimas actualizaciones y cambios',
      newProjectCreated: 'Nuevo proyecto creado',
      dashboardUpdated: 'Dashboard actualizado',
      entries: {
        summerSale: {
          title: 'Campaña de verano lanzada',
          time: 'Hace 2 horas',
        },
        keywordUpdate: {
          title: 'Nuevos rankings de keywords actualizados',
          time: 'Hace 5 horas',
        },
        weeklyReport: {
          title: 'Reporte semanal generado',
          time: 'Hace 1 día',
        },
      },
      timeAgo: {
        hoursAgo: 'hace {{count}} horas',
        daysAgo: 'hace {{count}} día',
        daysAgoPlural: 'hace {{count}} días',
      },
    },
    memberCount: {
      singular: 'miembro',
      plural: 'miembros',
    },
  },
} as const
